<script setup>
import { storeToRefs } from "pinia";
import Card from "@/components/Card.vue";
import Inplace from "primevue/inplace";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import imagemDuvida from '@/assets/duvida.svg';
import AcoesQuestoes from "@/components/professor/CriarQuestoes/AcoesQuestoes.vue";
import { useCriarQuestoesStore } from "@/store/criarQuestoes";
import FeedbackQuestao from "@/components/professor/CriarQuestoes/FeedbackQuestao.vue";

const store = useCriarQuestoesStore();
const { questoes, tipoPerguntaSelecionada, modeloQuestaoSelecionado } = storeToRefs(store);


function substituirAspasSimples(texto) {
    return texto.replace(/'/g, '"');
}

const opcoesGabarito = ["a", "b", "c", "d"];

function alterarAlternativaCorreta(alternativa, index){
    questoes.value[index].gabarito = alternativa
}

</script>
<template>
    <div class="flex flex-column gap-5">
        <Card v-for="(questao, index) in questoes" :key="index">

            <template #conteudo>
                <div class=" mb-3 w-full">
                    <Inplace :closable="false">
                        <template #display>
                            <div v-if="questao.conceitos != ''">{{ questao.conceitos }}</div>
                            <div class="text-color" v-if="questao.conceitos == ''">Adicionar conceitos</div>
                        </template>
                        <template #content>
                            <Textarea rows="1" v-model="questao.conceitos" autofocus autoResize class="w-full" />
                        </template>
                    </Inplace>
                </div>
                <div class="grid">
                    <!-- <div class="col-2 xl:col-1">

                    </div> -->
                    <div class="col-12 xl:col-12">
                        <div class="flex flex-column gap-4">
                            <div v-if="questao.texto" class="w-full text-color">
                                <Inplace :closable="false">
                                    <template #display>
                                        <div class="text-color">{{ substituirAspasSimples(questao.texto) }}</div>
                                    </template>
                                    <template #content>
                                        <Textarea rows="1" v-model="questao.texto" autofocus autoResize
                                            class="w-full" />
                                    </template>
                                </Inplace>
                            </div>
                            <div class="w-full">
                                <Inplace :closable="false">
                                    <template #display>
                                        {{ substituirAspasSimples(questao.pergunta) }}
                                    </template>
                                    <template #content>
                                        <InputText v-model="questao.pergunta" autofocus autoResize class="w-full" />
                                    </template>
                                </Inplace>
                            </div>
                        </div>

                        <div v-if="questao.a" class="flex flex-column gap-4 mt-5">
                            <div v-if="questao.a" class="flex flex-row gap-3 align-items-center">
                                <div class="font-semibold  border-round-md p-2 surface-200 cursor-pointer"
                                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'a' }"
                                    @click="alterarAlternativaCorreta('a', index)">
                                    A</div>
                                <div class="w-full">
                                    <Inplace :closable="false">
                                        <template #display>
                                            {{ substituirAspasSimples(questao.a) }}
                                        </template>
                                        <template #content>
                                            <Textarea rows="1" v-model="questao.a" autofocus autoResize
                                                class="w-full" />
                                        </template>
                                    </Inplace>
                                </div>
                            </div>
                            <div v-if="questao.b" class="flex flex-row gap-3 align-items-center">
                                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer"
                                    :class="{ 'bg-primary-500 text-white': questao.gabarito == 'b' }"
                                    @click="alterarAlternativaCorreta('b', index)">
                                    B</div>
                                <div class="w-full">
                                    <Inplace :closable="false">
                                        <template #display>
                                            {{ substituirAspasSimples(questao.b) }}
                                        </template>
                                        <template #content>
                                            <Textarea rows="1" v-model="questao.b" autofocus autoResize
                                                class="w-full" />
                                        </template>
                                    </Inplace>
                                </div>
                            </div>
                            <div v-if="questao.c" class="flex flex-row gap-3 align-items-center">
                                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer"
                                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'c' }"
                                    @click="alterarAlternativaCorreta('c', index)">
                                    C</div>
                                <div class="w-full">
                                    <Inplace :closable="false">
                                        <template #display>
                                            {{ substituirAspasSimples(questao.c) }}
                                        </template>
                                        <template #content>
                                            <Textarea rows="1" v-model="questao.c" autofocus autoResize
                                                class="w-full" />
                                        </template>
                                    </Inplace>
                                </div>
                            </div>
                            <div v-if="questao.d" class="flex flex-row gap-3 align-items-center">
                                <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer"
                                    :class="{ 'bg-primary-500 text-white': questao.gabarito === 'd' }"
                                    @click="alterarAlternativaCorreta('d', index)">D</div>
                                <div class="w-full">
                                    <Inplace :closable="false">
                                        <template #display>
                                            {{ substituirAspasSimples(questao.d) }}
                                        </template>
                                        <template #content>
                                            <Textarea rows="1" v-model="questao.d" autofocus autoResize
                                                class="w-full" />
                                        </template>
                                    </Inplace>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AcoesQuestoes :index="index" class="mt-3 lg:mt-4"/>
                <!-- <FeedbackQuestao :questao="questao" :tipo="tipoPerguntaSelecionada" :modelo="modeloQuestaoSelecionado.id" /> -->
            </template>

        </Card>

        <div v-if="questoes.length === 0">
            <div class="flex gap-5 p-4 justify-content-center flex-column align-items-center w-full">
                <img :src="imagemDuvida" alt="sem questões" class="mb-2 w-25rem" />
                <div class="text-2xl">Crie questões para vê-las aqui</div>
            </div>
        </div>

    </div>

</template>

<style>
.p-inplace .p-inplace-display {
    padding: 0px;
}
</style>
